import { Progress, Spinner, Text } from 'components/UI';
import CenterLoader from 'components/common/CenterLoader';

type UploadLoaderProps = {
  progress?: number;
  text?: string | null;
};

const UploadLoader = ({ progress, text }: UploadLoaderProps) => {
  const isUploadingFile = progress && progress > 0;
  const renderProgress = isUploadingFile ? <Progress value={progress} w="full" mb={4} /> : null;

  const renderText = text ? <Text>{text}</Text> : null;

  return (
    <CenterLoader wrapperProps={{ sx: { minWidth: 300, minHeight: 0 } }}>
      <Spinner size="xl" mb={6} thickness="5px" />
      {renderProgress}
      {renderText}
    </CenterLoader>
  );
};

export default UploadLoader;
